<template>
    <div class="row h-100">
        <!-- Display ticket detail on left side for on order detail page -->
        <div v-if="ticket && Object.keys(ticket).length && location == 'orderDetail'" class="col-md-3 border-end">
            <ticket-details
                :ticket="ticket"
                :ticket-status="ticketStatus"
                :currency="currency"
                :user="user"
            ></ticket-details>
        </div>
        <div class="col-md-9 pb-3">
            <template v-if="messages.length">
                <!-- Display selected ticket messages -->
                <div ref="messagesContainer" id="message-container" class="pt-3 pe-3 mb-3 flex-1 position-relative overflow-auto scrollbar" style="height: 300px">
                    <!-- Display message for the logged in user -->
                    <template v-for="(message, index) in messages" :key="index">
                        <div
                            v-if="message.user_id == user.id"
                            class="d-flex flex-row justify-content-end message-item"
                            :message-id="message.id"
                        >
                            <div class="text-end">
                                <div class="d-inline-block small p-2 mb-1 rounded-1 bg-info-subtle text-info-emphasis text-start" style="max-width: 75%;" v-html="message.message"></div>
                                <div class="small mb-3 rounded-1 text-muted hm-fs-12">
                                    <b>{{ message.user.first_name }}</b>
                                    <span class="ms-1 text-muted">
                                        <i class="bi bi-clock me-1"></i>{{ $dateTimeFormat(message.created_at, 'DD MMM YY, hh:mm A') }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div
                            v-else
                            class="d-flex flex-row justify-content-start message-item"
                            :message-id="message.id"
                        >
                            <div>
                                <div class="d-inline-block small p-2 mb-1 rounded-1 bg-primary-subtle text-primary-emphasis text-start" style="max-width: 75%;" v-html="message.message"></div>
                                <div class="small mb-3 rounded-1 text-muted hm-fs-12">
                                    <b>{{ message.user.first_name }}</b>
                                    <span class="ms-1 text-muted">
                                        <i class="bi bi-clock me-1"></i>{{ $dateTimeFormat(message.created_at, 'DD MMM YY, hh:mm A') }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <!-- Display chat input -->
                <Form
                    v-if="ticket.status == 'open'"
                    :validation-schema="chatInputSchema"
                    v-slot="{ handleMessageSubmit }"
                    as="div"
                    id="chat-form"
                    name="chat-form"
                    class=""
                >
                    <div class="row align-items-center gx-0">
                        <div class="col">
                            <div class="">
                                <Mentionable
                                    :keys="['@']"
                                    :items="mentionableUsers"
                                    offset="6"
                                    insert-space
                                    @open="toggleMentionDropdown(true)"
                                    @selected="onMentionSelected"
                                >
                                    <Field
                                        as="textarea"
                                        class="form-control bg-info-light align-middle hm-chat-textarea"
                                        name="chat_message"
                                        placeholder="Type your message and type @ to mention a user"
                                        rows="3"
                                        data-autosize="true"
                                        style="overflow: hidden; overflow-wrap: break-word;"
                                        v-model="chatMessage"
                                        @keydown="handleKeydown"
                                    ></Field>
                                </Mentionable>
                                <!-- <textarea name="message" id="message" class="form-control px-0 bg-info-light align-middle chat-textarea"
                                placeholder="Type your message..." rows="1" data-autosize="true" style="overflow: hidden; overflow-wrap: break-word; resize: none; height: 47px;"></textarea> -->
                            </div>
                        </div>
                        <!-- <div class="col-auto">
                            <button class="btn btn-icon btn-theme rounded-circle" type="button" @click="chatSubmit">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-send">
                                    <line x1="22" y1="2" x2="11" y2="13"></line>
                                    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                                </svg>
                            </button>
                        </div> -->
                    </div>
                </Form>
            </template>
            <template v-else-if="uuid != ''">
                <div class="d-flex justify-content-center">
                    <div class="spinner-border" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </template>

            <p v-if="uuid == ''" class="align-middle text-center mt-4"><a class="btn btn-theme cursor-pointer"  data-bs-toggle="modal" data-bs-target="#createTicket">Create a new ticket</a></p>
        </div>
        <div v-if="ticket && Object.keys(ticket).length && location == 'ticket'" class="col-md-3 border-start">
            <ticket-details
                :ticket="ticket"
                :ticket-status="ticketStatus"
                :currency="currency"
                :user="user"
            ></ticket-details>
        </div>
    </div>
</template>
<script>
import {Field} from "vee-validate";
import TicketDetails from "./TicketDetails";
import { Mentionable } from 'vue-mention'
import 'floating-vue/dist/style.css'

export default {
    name: 'TicketChat',
    props: {
        uuid: {
            type: String,
            default: () => ('')
        },
        location: {
            type: String,
            default: () => 'ticket'
        },
        currency: {
            type: String,
            default: () => '£'
        }
    },
    components: {
        Field,
        TicketDetails,
        Mentionable
    },
    data() {
        return {
            user: {},
            ticket: {},
            ticketStatus: false,
            messages: [],
            chatMessage: '',
            users: [], // staff users
            mentionableUsers: [],
            isMentionDropdownOpen: false
        }
    },
    mounted() {
        this.getTicketDetails();
        this.getTicketMessages();
        this.getStaffUsers();

        // Get new messages on every 5 seconds
        setInterval(() => {
            this.getTicketMessages();
        }, 5000);

        // Receive the ticket status change
        this.$emitter.on('updateTicketStatus', (data) => {
            this.ticketStatus = data;
        });
    },
    computed: {
        chatInputSchema() {
            return {
                chat_message: 'required'
            }
        }
    },
    methods: {
        getTicketDetails() {
            axios.post(this.$baseUrl + '/admin/tickets/get-ticket', {uuid: this.uuid})
                .then((response) => {
                    if(response.data.status === 'success') {
                        this.user = response.data.user;
                        this.ticket = response.data.ticket;
                        this.ticketStatus = response.data.ticket.status == 'open' ? true : false;
                    }
                });
        },
        getTicketMessages() {
            // Check if uuid is empty then no need to call the API
            if (this.uuid.trim() == '') {
                return false;
            }

            axios.post('/admin/tickets/discussion/' + this.uuid)
                .then((response) => {
                    if(response.data.status === 'success') {
                        // Check if new messages are available then scroll to the bottom
                        let scrollToBottom = false;
                        if (response.data.messages.length > this.messages.length) {
                            scrollToBottom = true;
                        }

                        this.messages = response.data.messages;

                        // Scroll to the bottom
                        if (scrollToBottom) {
                            this.scrollToBottom();
                        }
                    }
                });
        },
        scrollToBottom() {
            this.$nextTick(() => {
                const container = this.$refs.messagesContainer;
                if (container) {
                    container.scrollTop = container.scrollHeight;
                }
            });
        },
        handleKeydown(event) {
            if (event.key === "Enter") {
                if (this.isMentionDropdownOpen) {
                    // If dropdown is open, apply mention and prevent form submission
                    event.preventDefault();
                    this.applyMention();
                } else if (!event.shiftKey) {
                    // Prevent default action when Enter is pressed without Shift
                    event.preventDefault();
                    this.chatSubmit(); // Call submit function
                }
            }
        },
        applyMention() {
            // Logic to apply mention from the dropdown
            // This function should contain the logic to apply the mention.
            // For example, you might select the mention from the dropdown and insert it into the chatMessage.
            console.log("Mention applied:", this.chatMessage);
            // Reset mention dropdown state
            this.isMentionDropdownOpen = false;
        },
        onMentionSelected(mention) {
            // Logic to handle when a mention is selected
            this.chatMessage += mention; // Append the mention to the chat message
            this.isMentionDropdownOpen = false; // Close the mention dropdown
        },
        // Example method to trigger dropdown open/close
        toggleMentionDropdown(isOpen) {
            this.isMentionDropdownOpen = isOpen;
        },
        chatSubmit() {
            // First check if message is empty then return
            if (this.chatMessage.trim() == '') {
                return false;
            }
            console.log(this.chatMessage);
            let self = this;
            // Push the new message to the messages array
            let newMsgData = {
                message: this.chatMessage,
                user_id: this.user.id,
                user: this.user
            }
            this.messages.push(newMsgData);
            axios.post('/admin/tickets/store-discussion', {
                uuid: this.uuid,
                message: this.chatMessage
            })
                .then((response) => {
                    if(response.data.status === 'success') {

                    }
                })
                .catch((error) => {
                    let message = error.response.data.message;
                    this.$notification('error', message);
                })
                .finally(() => {

                });

            this.chatMessage = '';
            this.scrollToBottom();
        },
        updateTicketStatus() {
            let self = this;
            axios.post('/admin/tickets/update-ticket-status', {
                uuid: this.uuid,
                status: this.ticket.status
            })
                .then((response) => {
                    if(response.data.status === 'success') {
                        //self.$notification('success', response.data.message);
                    }
                })
                .catch((error) => {
                    let message = error.response.data.message;
                    self.$notification('error', message);
                })
                .finally(() => {

                });
        },
        getStaffUsers() {
            let self = this;
            axios.post('/admin/staff/get-list')
                .then(response => {
                    self.users = [];
                    if(response.data.status === 'success') {
                        self.users = response.data.users;

                        // Get id and name of users and push into the userOptions
                        response.data.users.forEach((user) => {
                            self.mentionableUsers.push({value: user.first_name.toLowerCase()+'-'+user.id, label: user.full_name});
                        });
                    }
                });
        }
    },
    watch: {
        ticketStatus() {
            if (this.ticketStatus) {
                this.ticket.status = 'open';
            } else {
                this.ticket.status = 'closed';
            }

            this.updateTicketStatus();
        }
    }
}
</script>
<style>
.mention-item {
  padding: 4px 10px;
  border-radius: 4px;
  cursor: pointer;
}

.mention-selected {
  background: rgb(192, 250, 153);
}
</style>
